import { FormsFeatureContext } from "@ngt/forms";
import { useContext, useCallback } from "react";
import { Report, SendEmailOnlyReportEmail, SendEmailsResponse } from "../../api/dtos";


const usePostEmailTrigger = () => {
    const formsFeature = useContext(FormsFeatureContext);
        
        // @ts-ignore
    const postEmailTrigger = useCallback(async (report?: Report) => {
        const response: SendEmailsResponse = await formsFeature.serviceStackClient.post(
            new SendEmailOnlyReportEmail({ 
                report: report
            }))

        return response.responseStatus;
    }, [formsFeature.serviceStackClient]);

    return postEmailTrigger;

}

export default usePostEmailTrigger;